import axionIns from "../axios";

const getAuthorisationCall = (company) => {
  return axionIns
    .get("myinfo/getMyinfoAuthoriseApi/" + company)
    .then((response) => {
      return response.data;
    });
};

const getMyInfoData = (payload) => {
  return axionIns.post("myinfo/getMyInfoData", payload).then((response) => {
    return response.data;
  });
};

const addInfoQUestions = (payload) => {
  return axionIns.post("company/addinfoquestions", payload).then((response) => {
    return response.data;
  });
};

const getAuthorisationPublicCall = (company) => {
  return axionIns
    .get("auth/myinfo/getMyinfoAuthoriseApi/" + company)
    .then((response) => {
      return response.data;
    });
};

const getMyInfoDataPublic = (payload) => {
  return axionIns.post("auth/myinfo/getMyInfoData", payload).then((response) => {
    return response.data;
  });
};


const exportObject = {
  getAuthorisationCall,
  getMyInfoData,
  addInfoQUestions,
  getAuthorisationPublicCall,
  getMyInfoDataPublic
};
export default exportObject;
